import React from 'react'
import { Box } from 'rebass/styled-components'

const ErrorMessage = ({ children }) => {
  return <Box sx={{ fontSize: 1, color: 'secondary' }}>{children}</Box>
}

export default ErrorMessage
